package diana.soleil.design.iraniancanadienbazzar.feature.gems

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/**
 * Koin bindings for the Hidden Gems feature (`docs/HIDDEN_GEMS_PLAN.md`). Aggregated by `:shared`.
 * `RecipeDetailViewModel` is parameterized by recipe id and shared by the detail + cook-mode
 * routes (each gets its own instance keyed by the nav entry).
 */
val gemsModule = module {
    viewModel { GemsHubViewModel(get(), get()) }
    viewModel { JokesViewModel(get(), get(), get(), get(), get()) }
    viewModel { DanestanihaViewModel(get(), get(), get()) }
    viewModel { ShahnamehViewModel(get(), get()) }
    viewModel { (taleId: String) -> TaleDetailViewModel(get(), get(), get(), taleId) }
    viewModel { PoetryViewModel(get()) }
    viewModel { (poetId: String) -> PoetPoemsViewModel(get(), poetId) }
    viewModel { (poemId: String) -> PoemDetailViewModel(get(), get(), get(), poemId) }
    viewModel { StoriesViewModel(get()) }
    viewModel { FalViewModel(get(), get(), get()) }
    viewModel { (storyId: String) -> StoryDetailViewModel(get(), get(), get(), storyId) }
    viewModel { RecipesViewModel(get()) }
    viewModel { (recipeId: String) -> RecipeDetailViewModel(get(), get(), get(), recipeId) }
}
